package org.vreo.devicehub.features.core.domain.device.webRtc

import kotlinx.serialization.Serializable

/**
 * Web rtc config for requesting offer, or receiving answer, for peer-to-peer device communication
 *
 * @property sdp session description protocol
 * @property type session type and description
 */
@Serializable
data class WebRtcOfferAnswer(
    val sdp: String,
    val type: String
)